/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B100113 商品マスタ出力
 */
import { Box } from "@mui/material";
import {
  B100113ExcelRequest,
  B100113GetExcel,
  catchFileError,
  B000202ShohindaibunruiNmFrom,
  B000202ShohindaibunruiNmTo,
  B000202ShohinchubunruiNmFrom,
  B000202ShohinchubunruiNmTo,
  B000202ShohinshobunruiNmFrom,
  B000202ShohinshobunruiNmTo,
  B100113ShohinNmFrom,
  B100113ShohinNmTo,
  B100113JanShohinNmFrom,
  B100113JanShohinNmTo,
} from "clients/rest";
import {
  msgState,
  SConfirmDialog,
  SFileButton,
  SFrame,
  SLabel,
  SNumberField,
  SText,
  STextField,
} from "components";
import { getClientMessage } from "messages";
import { labels } from "messages/labels";
import { B000200, B000202 } from "pages";
import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { download } from "services";
import { focusState, useFocus } from "states";

// 呼び出し時のプロパティ
type Props = Partial<{}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  shodaibunFrom: string;
  shohindaibunruiNmFrom: string;
  shodaibunTo: string;
  shohindaibunruiNmTo: string;
  shochubunFrom: string;
  shohinchubunruiNmFrom: string;
  shochubunTo: string;
  shohinchubunruiNmTo: string;
  shoshobunFrom: string;
  shohinshobunruiNmFrom: string;
  shoshobunTo: string;
  shohinshobunruiNmTo: string;
  shohinCdFrom: string;
  shohinNmFrom: string;
  shohinCdTo: string;
  shohinNmTo: string;
  janCdFrom: string;
  janShohinNmFrom: string;
  janCdTo: string;
  janShohinNmTo: string;
}>;

// フィールドの初期値を設定する。
const defaultFields: Fields = {
  shodaibunFrom: "",
  shohindaibunruiNmFrom: "",
  shodaibunTo: "",
  shohindaibunruiNmTo: "",
  shochubunFrom: "",
  shohinchubunruiNmFrom: "",
  shochubunTo: "",
  shohinchubunruiNmTo: "",
  shoshobunFrom: "",
  shohinshobunruiNmFrom: "",
  shoshobunTo: "",
  shohinshobunruiNmTo: "",
  shohinCdFrom: "",
  shohinNmFrom: "",
  shohinCdTo: "",
  shohinNmTo: "",
  janCdFrom: "",
  janShohinNmFrom: "",
  janCdTo: "",
  janShohinNmTo: "",
};

const focusId = "B100113";

export const B100113 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

const Page = (props: Props) => {
  // 状態管理の初期設定
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });
  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));
  // 画面遷移
  const navigate = useNavigate();
  // エラー表示
  const setMsg = useSetRecoilState(msgState);

  // 初期表示イベント
  useEffect(() => {
    // 初回フォーカス先
    focus(1);
  }, []);

  // EXCELボタン押下時
  const handleClickExcelButton = () => {
    const fields = methods.getValues();

    const param: B100113ExcelRequest = {
      shodaibunFrom: fields.shodaibunFrom!,
      shodaibunTo: fields.shodaibunTo!,
      shochubunFrom: fields.shochubunFrom!,
      shochubunTo: fields.shochubunTo!,
      shoshobunFrom: fields.shoshobunFrom!,
      shoshobunTo: fields.shoshobunTo!,
      shohinCdFrom: fields.shohinCdFrom!,
      shohinCdTo: fields.shohinCdTo!,
      janCdFrom: fields.janCdFrom!,
      janCdTo: fields.janCdTo!,
    };

    B100113GetExcel(param)
      .then((response) => {
        download(response);
        setMsg(getClientMessage("B100113_001"));
      })
      .catch((reason) => {
        catchFileError(reason, navigate, setMsg);
      });
  };

  // レイアウト設定
  return (
    <FormProvider {...methods}>
      <SFrame
        title="商品マスタ出力"
        gridTemplateColumns="9rem 4rem 5rem 15rem 1rem 4rem 5rem 15rem 5rem"
      >
        <SText gridColumn="span 9">　</SText>

        <SLabel>商品大分類コード</SLabel>
        <SNumberField
          name="shodaibunFrom"
          code
          size={3}
          {...register(1)}
          dialog={<B000202 />}
          handleSubmit={(data: any) => {
            methods.setValue("shodaibunFrom", data.shodaibun ?? "");
            methods.setValue(
              "shohindaibunruiNmFrom",
              data.shohindaibunruiNm ?? ""
            );
          }}
          onBlur={() => B000202ShohindaibunruiNmFrom(methods, navigate, setMsg)}
        />
        <STextField name="shohindaibunruiNmFrom" disabled gridColumn="span 2" />
        <SText>～</SText>
        <SNumberField
          name="shodaibunTo"
          code
          size={3}
          {...register(2)}
          dialog={<B000202 />}
          handleSubmit={(data: any) => {
            methods.setValue("shodaibunTo", data.shodaibun ?? "");
            methods.setValue(
              "shohindaibunruiNmTo",
              data.shohindaibunruiNm ?? ""
            );
          }}
          onBlur={() => B000202ShohindaibunruiNmTo(methods, navigate, setMsg)}
        />
        <STextField name="shohindaibunruiNmTo" disabled gridColumn="span 2" />

        <SLabel gridColumn="1">商品中分類コード</SLabel>
        <SNumberField
          name="shochubunFrom"
          code
          size={3}
          {...register(3)}
          dialog={<B000202 />}
          handleSubmit={(data: any) => {
            methods.setValue("shochubunFrom", data.shochubun ?? "");
            methods.setValue(
              "shohinchubunruiNmFrom",
              data.shohinchubunruiNm ?? ""
            );
          }}
          onBlur={() => B000202ShohinchubunruiNmFrom(methods, navigate, setMsg)}
        />
        <STextField name="shohinchubunruiNmFrom" disabled gridColumn="span 2" />
        <SText>～</SText>
        <SNumberField
          name="shochubunTo"
          code
          size={3}
          {...register(4)}
          dialog={<B000202 />}
          handleSubmit={(data: any) => {
            methods.setValue("shochubunTo", data.shochubun ?? "");
            methods.setValue(
              "shohinchubunruiNmTo",
              data.shohinchubunruiNm ?? ""
            );
          }}
          onBlur={() => B000202ShohinchubunruiNmTo(methods, navigate, setMsg)}
        />
        <STextField name="shohinchubunruiNmTo" disabled gridColumn="span 2" />

        <SLabel gridColumn="1">商品小分類コード</SLabel>
        <SNumberField
          name="shoshobunFrom"
          code
          size={3}
          {...register(5)}
          dialog={<B000202 />}
          handleSubmit={(data: any) => {
            methods.setValue("shoshobunFrom", data.shoshobun ?? "");
            methods.setValue(
              "shohinshobunruiNmFrom",
              data.shohinshobunruiNm ?? ""
            );
          }}
          onBlur={() => B000202ShohinshobunruiNmFrom(methods, navigate, setMsg)}
        />
        <STextField name="shohinshobunruiNmFrom" disabled gridColumn="span 2" />
        <SText>～</SText>
        <SNumberField
          name="shoshobunTo"
          code
          size={3}
          {...register(6)}
          dialog={<B000202 />}
          handleSubmit={(data: any) => {
            methods.setValue("shoshobunTo", data.shoshobun ?? "");
            methods.setValue(
              "shohinshobunruiNmTo",
              data.shohinshobunruiNm ?? ""
            );
          }}
          onBlur={() => B000202ShohinshobunruiNmTo(methods, navigate, setMsg)}
        />
        <STextField name="shohinshobunruiNmTo" disabled gridColumn="span 2" />

        <SLabel required gridColumn="1">
          商品コード
        </SLabel>
        <SNumberField
          name="shohinCdFrom"
          label="商品コード(開始)"
          code
          required
          gridColumn="span 2"
          size={10}
          {...register(7)}
          dialog={<B000200 deljogaiKbn="1" />}
          handleSubmit={(data: any) => {
            methods.setValue("shohinCdFrom", data.shohinCd ?? "");
            methods.setValue("shohinNmFrom", data.shohinNm ?? "");
          }}
          onBlur={() => B100113ShohinNmFrom(methods, navigate, setMsg)}
        />
        <STextField name="shohinNmFrom" disabled />
        <SText>～</SText>
        <SNumberField
          name="shohinCdTo"
          label="商品コード(終了)"
          code
          gridColumn="span 2"
          size={10}
          {...register(8)}
          dialog={<B000200 deljogaiKbn="1" />}
          handleSubmit={(data: any) => {
            methods.setValue("shohinCdTo", data.shohinCd ?? "");
            methods.setValue("shohinNmTo", data.shohinNm ?? "");
          }}
          onBlur={() => B100113ShohinNmTo(methods, navigate, setMsg)}
        />
        <STextField name="shohinNmTo" disabled />

        <SLabel gridColumn="1">JANコード</SLabel>
        <SNumberField
          name="janCdFrom"
          code
          gridColumn="span 2"
          size={13}
          {...register(9)}
          onBlur={() => B100113JanShohinNmFrom(methods, navigate, setMsg)}
        />
        <STextField name="janShohinNmFrom" disabled />
        <SText>～</SText>
        <SNumberField
          name="janCdTo"
          code
          gridColumn="span 2"
          size={13}
          {...register(10)}
          onBlur={() => B100113JanShohinNmTo(methods, navigate, setMsg)}
        />
        <STextField name="janShohinNmTo" disabled />

        <SText gridColumn="span 9">　</SText>
        <SText gridColumn="span 9">　</SText>
        <SText gridColumn="span 9">　</SText>

        <Box gridColumn="span 7" />
        <SFileButton
          label={labels.buttons.excel}
          align="right"
          {...register(11)}
          dialog={
            <SConfirmDialog
              title="商品マスタ出力"
              msg={labels.dialog.masterExcelConfirmMessage}
            />
          }
          dialogAction="confirm"
          handleSubmit={handleClickExcelButton}
        />
      </SFrame>
    </FormProvider>
  );
};
